import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=fd8c1192&scoped=true&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=fd8c1192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8c1192",
  null
  
)

export default component.exports